import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4bc9d7de&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc9d7de')) {
      api.createRecord('4bc9d7de', component.options)
    } else {
      api.reload('4bc9d7de', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4bc9d7de&", function () {
      api.rerender('4bc9d7de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Index.vue"
export default component.exports